<template>
  <div class="bookmark-holder">
    <div
      ref="bookmarkBox"
      class="bookmark-box"
    >
      <div
        ref="bookmark"
        class="bookmark"
      >
        <img
          :src="require('@/assets/svg/SVG/bookmark_g.svg')"
          alt="Bookmark/"
        >
        <img
          :src="require('@/assets/svg/SVG/bookmark_w.svg')"
          alt="Bookmark/"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';

export default {
  name: 'SavedMarker',
  methods: {
    highlight () {
      gsap.to(this.$refs.bookmarkBox, {
        backgroundColor: '#0088ca',
        duration: 0
      });
      gsap.to(this.$refs.bookmark, {
        y:-25,
        duration: 0
      });
    },
    unhighlight () {
      gsap.to(this.$refs.bookmarkBox, {
        backgroundColor: 'transparent',
        duration: 0
      });
      gsap.to(this.$refs.bookmark, {
        y:0,
        duration: 0
      });
    }
  }
};
</script>

<style scoped>
.bookmark-holder {
  align-self: end;
}
.bookmark-box {
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.bookmark {
  width: 18px;
  height: 18px;
}
.bookmark img, .bookmark-list img {
  width: 100%;
  height: 100%;
}
</style>